import artGallery from "../images/art-gallery.jpg";
import druzhba from "../images/druzhba-cinema.jpg";
import culturePalace from "../images/culture-palace.jpg";
import fdepot from "../images/ff-station.JPG";
import fmonument from "../images/furmanov-monument.jpg";
import gorbunovMansion from "../images/gorbunov-mansion.JPG";
import restorant from "../images/restorant.JPG";
import houseofculture from "../images/club.jpg";
import museum from "../images/museum.jpg";
import novozhilovMansion from "../images/novozhilov-mansion.jpg";
import holchevskaya from "../images/holchevskaya.JPG";
import churchVG from "../images/churchVG.JPG";
import vokzal from "../images/vokzal.jpg";
import churchPPB from "../images/churchPPB.jpg";
import churchVSR from "../images/churchVSR.jpg";
import workhouse from "../images/workhouse.JPG";
import school8 from "../images/school8.jpg";
import oldschool7 from "../images/oldschool7.jpg";
import factory1 from "../images/factory1.JPG";
import clinic from "../images/clinic.jpg";
import hospital from "../images/hospital.jpg";
import factorypark from "../images/park.JPG";
import germanHouse from "../images/german-house.jpg";
import glorymonument from "../images/hero-monument.jpg";
import alley from "../images/alley.jpg";
import gosbank from "../images/bank1.JPG";
import crk from "../images/crk.jpg";
import klementievMansion from "../images/klementiev-mansion.jpg";
import summerGarden from "../images/summer-garden.jpg";
import skazka from "../images/skazka.jpg";
import stadium from "../images/stadium.JPG";

const objectsData = [
  {
    id: "churchvsr",
    title: "Храм иконы Божией Матери «Всех скорбящих Радость» ",
    image: churchVSR,
    text: "Основание собора заложено в 1897 г. Храм построен по плану и под наблюдением московского архитектора П.П. Зыкова на средства Павловых Петра Александровича и Матрены Ивановны, владельцев «Товарищества мануфактур, основанных И.И. Скворцовым». 13 февраля 1905 г. храм был освящен. Собор венчает 21 купол, внутри сохранился мраморный иконостас.",
  },
  {
    id: "holchevskaya",
    title: "Холчевский особняк",
    image: holchevskaya,
    text: "В к. 19 в. Купец, фабрикант Скворцов И.И. покупает  у бывшего владельца села Середа  Г.В. Грудева, начальника удельной конторы Московской губернии усадьбу, на территории которой располагались особняк, парк, фонтаны, оранжерея, конюшни. Впоследствии усадьба перешла во владение к дочери Матрене Ивановне, которая вышла замуж за фабриканта П.А. Павлова. В 1910 г. она второй раз вступает в брак за коллежского секретаря И.Н. Холчева. А в народе название усадьбы закрепилось как «холчевская».",
  },
  {
    id: "muzey",
    title: "Музей Фурманова",
    image: museum,
    text: "Здание, в котором разместился мемориальный музей Д.А. Фурманова, построено во второй половине XIX в. и принадлежало торговцу Медведеву И.А. До 1897 г. семья Д.А.Фурманова снимала здесь комнату, где 07.11.1891 г. родился будущий писатель Д.А. Фурманов, автор бестселлера «Чапаев». Основателем и первым директором музея стал учитель В.А. Лапшин, а первыми экскурсоводами – его ученики. В 1960 г. музею было присвоено звание Народного, а само здание взято под охрану как памятник федерального значения. В 1968 г. музей получает статус государственного и входит в состав Ивановского областного краеведческого музея (ныне ГБУИО «ИГИКМ им. Д.Г. Бурылина»)",
  },
  {
    id: "churchvg",
    title: "Храм Вознесения Господня",
    image: churchVG,
    text: "Церковь Вознесения Господня построена на месте пришедшей в ветхость деревянной, впервые упомянутой в 1614 году. В 1727 г. издан указ о строении церкви по челобитной генерал-майора князя И. Ф.Барятинского в селе Середе-Упине вместо ветхой Вознесенской церкви. Престолов 3: в честь Вознесения Господня, Покрова Божией Матери, Федоровской иконы Божией матери. Местной святыней считался образ Кипрской Божией матери, который по преданию был оставлен в храме монахами о. Кипр, когда они проезжали в Москву для сбора на обители Кипра.",
  },
  {
    id: "vokzal",
    title: "ЖД Вокзал",
    image: vokzal,
    text: "Фабриканты Горбунов Г.К.  и Скворцов И.И.  заключают договор с правлением Шуйско-Ивановской железной дороги на строительство «железнодорожной ветки от станции Ермолино в места нахождения фабрик у села Середы. Для этого они выдали правлению железной дороги ссуду в 350 тыс. рублей сроком на 20 лет. Проект был реализован в 1892 г. Тогда же был построен железнодорожный вокзал, вмещавший около 80 человек. В 1896 г. железная дорога продолжена от Середы до Нерехты.",
  },
  {
    id: "churchppb",
    title: "Храм Покрова Пресвятой Богородицы",
    image: churchPPB,
    text: "Храм построен на средства фабриканта Г.К. Горбунова. Освящение храма состоялось 14 октября 1907 г. Принадлежал старообрядцам-беспоповцам федосеевского толка. Пятиглавая церковь с трапезной и шатровой колокольней, не имела алтаря, иконостас закрывал  стену. Архитектурные формы здания стилизованы под древнерусские.",
  },

  {
    id: "gallery",
    title: "Картинная галерея им. Д.А. Тубникова",
    image: artGallery,
    text: "Трехэтажное деревянное здание, построенное в к. ХIХ в. для дочери Г.К. Горбунова – Александры, вышедшей замуж за Лосева Н.И., инженера, заведующего хозяйственной частью фабрики. Уже в советское время в здании располагались, ШРМ,  начальная школа, потом станция юных техников, а с 1989г. в здании разместилась картинная галерея им. Д.А. Тубникова.",
  },
  {
    id: "summerGarden",
    title: "Летний Сад",
    image: summerGarden,
    text: "Обширный парк : живописный, неправильной формы пруд, тенистые аллеи лип, берез и тополей, изящная беседка,  – входил в состав усадьбы Г.К. Горбунова. В 20-е годы прошлого столетия  парк был взят в аренду середскими комсомольцами и был открыт для жителей города в 1922 году. В народе он получает название Летний сад.  Планировку сада выполнил художник Д.А.  Трубников.",
  },

  {
    id: "gorbunovmansion",
    title: "Особняк Г.К. Горбунова",
    image: gorbunovMansion,
    text: "Здание постройки к. 19 в. Принадлежало фабриканту Г.К. Горбунову. «Солидный, с претензией на роскошь кирпичный особняк, стены которого увенчаны грузным карнизом, украшен самым разнообразным архитектурным убранством – рустовкой, наличниками, филенками…». Внутреннее убранство: 16 комнат, ажурная чугунная лестница, лепные потолки, камин.",
  },
  {
    id: "klementievMansion",
    title: "Клементьевский особняк",
    image: klementievMansion,
    text: "Принадлежал фабрикантам Клементьевым. Двухэтажный каменный дом постройки второй половины 19 в. Для него характерно простое архитектурное решение без излишеств. В особняке было 13 комнат, электрическое освещение, баня, печное отопление. В настоящее время в здании размещается военкомат.",
  },
  {
    id: "skazka",
    title: "Кафе «Сказка»",
    image: skazka,
    text: "Это детище знаменитого на весь Советский Союз Фурмановского торга, который возглавлял легендарный С. Л. Плешанов. Построены в 1980-е гг. Кафе было предназначено для детей и родителей. В кафе не продавали спиртные напитки, здесь можно было отдохнуть, отметить  день рождения, отведать пирожных, мороженое, соки… Кафе пользовалось большой популярностью среди жителей города. Здание стоит на месте Клементьевской мануфактуры.",
  },

  {
    id: "novozhilovmansion",
    title: "Новожиловский особняк",
    image: novozhilovMansion,
    text: "2-х этажный особняк, в котором в наши дни разместился банк. Принадлежал братьям Новожиловым, которые держали  галантерейные лавки. В 1919 - 1921 годах на втором этаже здания располагался Середской уездный комитет РКСМ. Здесь принимались решения о мобилизации на фронты Гражданской войны, отсюда отправлялись продотряды за хлебом, здесь планировалась борьба с безграмотностью. В 2017 году начинается реконструкция здания, в результате которой был полностью уничтожен декор наружных стен.",
  },
  {
    id: "school8",
    title: "Школа № 8",
    image: school8,
    text: "Двухэтажное здание построено в 1896 г. на средства фабрикантов Горбуновых  для детей рабочих и служащих. Внутри здание украшают чугунные ажурные лестницы, полы выложены метлахской плиткой. На первом этаже помимо классов находился рекреационный зал, где проходили литературные вечера, синематографические сеансы. Отопление в школе было паровое.",
  },
  {
    id: "hospital",
    title: "Больница",
    image: hospital,
    text: "Двухэтажное здание из красного кирпича, построенное на средства Г.К. Горбунова для рабочих и служащих фабрики. При больнице находились аптека и родильный приют. Все кабинеты и палаты были оборудованы по последнему слову медицинской техники того времени. В настоящее время в здании размещаются хирургическое и гинекологическое отделения (стационар).",
  },
  {
    id: "clinic",
    title: "Поликлиника",
    image: clinic,
    text: "Поликлиника (бывшая силовая электрическая подстанция «Т-ва мануфактур Бр. Г. и А. Горбуновых»)Здание построено в 1913 г., здесь  был установлен паро-турбо-генератор в 3600 лош.сил  берлинской фирмы «Сименсъ Шукертъ». В феврале 1927 г. здание было переоборудовано в центральную амбулаторию, которую называли «лучшей в губернии фабрикой здоровья»",
  },
  {
    id: "workhouse",
    title: "Дома для рабочих",
    image: workhouse,
    text: "Дома для рабочих фабрики Горбунова. Здания, построенные из красного кирпича, предназначались для рабочих, приходивших  на фабрику из дальних деревень, и были обустроены  по принципу солдатских казарм. Так как комнаты  были очень маленькие, то в народе  их  прозвали «каморками». В 1980-е гг. дома  перепланировали и перестроили под комфортабельные квартиры.",
  },
  {
    id: "culturepalace",
    title: "Центральный Дворец Культуры",
    image: culturePalace,
    text: "4 ноября 1977 года в Фурманове состоялось открытие Дворца культуры текстильщиков (Центральный Дворец Культуры). Общая площадь ЦДК составляет 5584 кв.м, площадь сцены— 180 кв.м. Здание сразу же стало одной из визитных карточек города.",
  },
  {
    id: "factorypark",
    title: "Парк Фабрики №1",
    image: factorypark,
    text: "Ул. Белова (в прошлом Верхний Двор). Парк был центром культурно-массовой работы клуба фабрики № 1, которая  несла ответственность за состояние парка, за мероприятие, проводимые в нем, за порядок. 100 лет назад в парке были высажены деревья: липы, березы, тополя, кустарники. Здесь были оборудованы танцевальная, детская и спортивная площадки, эстрада, фонтан, карусель. Зрителей обслуживали клубные кружки и профессиональные  артисты. Там же в парке на свежем воздухе в 50-е гг.  ежедневно демонстрировались научные и документальные фильмы.",
  },
  {
    id: "factory1",
    title: "Фабрика №1",
    image: factory1,
    text: "Улица Социалистическая, Фабрика № 1, бывшее «Т-во мануфактур, основанных И.И. Скворцовым». В 1871  И.И. Скворцовым  построена  ткацкая фабрика, которую  после  его смерти в 1892 наследовали дочь Матрена Ивановна и ее муж Петр Александрович Павловы. Последним владельцем фабрики был их сын Николай Петрович, который в 1912 г. построил второй прядильный корпус. В нач. 1910-х на предприятиях производилось продукции на 15 млн. руб., численность занятых рабочих - 6500 человек. В советское время фабрика носила название – Верхняя, а уже потом ф-ка № 1.",
  },
  {
    id: "fmonument",
    title: "Памятник Д.А. Фурманову",
    image: fmonument,
    text: "Памятник  открыт 4 ноября 1960 г. Автор монумента – скульптор Н.В. Дыдыкин, заслуженный деятель искусств РСФСР. Изготовлен на Ленинградском заводе «Монумент - скульптура». В оформлении принял участие художник – архитектор А.А. Лапиров. Фигура  изготовлена из бронзы,  постамент – из серого гранита. Общая высота памятника 6,5 метров. Возле памятника разбита аллея. Постановлением СМ РСФСР № 624 от 04.12.1974 г. монумент внесен в реестр как памятник федерального значения.",
  },
  {
    id: "restorant",
    title: "Здание полиции",
    image: restorant,
    text: "3-х этажное каменное здание построено в к.19 - н.20 вв. и принадлежало Шувалову. На первом этаже размещался зал ресторана, на втором – бильярдная, третий этаж – гостиница, в подвале хранились продукты, вино и другие припасы. В советское время здание занимали  горком партии, потом  дом пионеров.",
  },
  {
    id: "alley",
    title: "Аллея",
    image: alley,
    text: "Первоначальное  название  «Аллея борцов за дело революции и Героев Советского Союза – фурмановцев». Заложена в 1934 году от ж/д станции  до центра. Жители города вышли на субботники по благоустройству. Высаживали деревья, кустарники, заваливали рытвины и ухабы, сделали торцовую мостовую. В 2016 году проведены работы по благоустройству аллеи: положили тротуарную плитку с подсветкой, разбили цветники. Поставили новые скамейки. В центре разбили цветочную клумбу.",
  },
  {
    id: "houseofculture",
    title: "Дом культуры",
    image: houseofculture,
    text: "В 1949 г. выстроено двухэтажное красивое здание с массивными колоннами, с большими окнами, с балконами – Дом культуры. Зрительный зал вмещал  575 человек, оборудованы комнаты для кружковой работы, большой читальный зал, библиотека, танцевальная площадка, работала стационарная киноустановка. В настоящее время в здании размещается торговый центр.",
  },
  {
    id: "fdepot",
    title: "Пожарное депо",
    image: fdepot,
    text: "В 1936 г. горсовет принял решение о постройке в Середе нового пожарного депо. На строительство заложено  200 тысяч рублей. В  1938 году построена пожарная каланча. Ввод в эксплуатацию здания пожарного депо состоялся в 1939 г. Летом при температуре +25 градусов и выше, а зимой при температуре ниже 30 градусов над каланчой  поднимали  флаг.",
  },
  {
    id: "gosbank",
    title: "Здание прокуратуры",
    image: gosbank,
    text: "Здание прокуратуры (бывшее здание Госбанка). Строительство здания Госбанка началось в 1937 г. Введено в строй в конце 1939 г. В 2000-е гг. в здании разместилась прокуратура.",
  },
  {
    id: "glorymonument",
    title: "Монумент славы",
    image: glorymonument,
    text: "Открыт 9 мая 1985 года к 40-летию Победы в Великой Отечественной войне. Автор проекта – Шахматов В.М., архитектор института  «Ивановогражданпроект». Монумент возводился силами предприятий города Фурманова. Накануне открытия памятника ветераны войны высадили на территории вокруг памятника 40 берез. В 2013 году проведены работы по реконструкции и озеленению парковой зоны вокруг монумента.",
  },

  {
    id: "druzhbacinema",
    title: "Кинотеарт «Дружба» ",
    image: druzhba,
    text: "Здание было выстроено в стиле «конструктивизм». Проект выполнен в бюро Иваново-Вознесенского государственного текстильного треста. Сдано в эксплуатацию 7 ноября 1929 года. Получил название Народного дома. Зал был рассчитан на 960 мест. Это был центр общественной и культурной жизни горожан. В 1935 году был показан фильм «Чапаев», созданный по одноименному роману Д. А. Фурманова. В 1962 году исполком горсовета принял решение присвоить городскому кинотеатру название «Дружба». В 2000-е здание опустело, стояло бесхозным, памятник конструктивизма сравняли с землей.",
  },
  {
    id: "oldschool7",
    title: "«Старая» седьмая школа",
    image: oldschool7,
    text: "Основной объем работ по сооружению школы был выполнен в 1929 г. В основе лежал проект ивановского архитектора Н.И. Кадникова. Здание типовое, стиль «конструктивизм». Открылась школа 17 сентября 1930 года. Это было первое среднее учебное заведение в Середе. В годы Великой Отечественной войны в здании разместился эвакогоспиталь № 1886. В 1991 году школа № 7 переехала в новое здание. В старом до 2007г. располагался Центр детского творчества. В октябре 2007 года пустующее здание бывшей школы № 7 сгорело.",
  },
  {
    id: "germanHouse",
    title: "Жилой дом",
    image: germanHouse,
    text: "3-х этажное здание из красного кирпича. Когда-то это был элитный дом с отдельными квартирами. В подвале дома была автономная котельная. Строили дом немецкие военнопленные в к. 1940-х гг.",
  },
  {
    id: "stadium",
    title: "Стадион",
    image: stadium,
    text: "В 1925 г. Середской уездный исполком выделил  1500 рублей на достройку стадиона на Лопатинском поле. В конце 1920-х стадион был введен в строй. В советское время находился на балансе фабрики № 2.",
  },
  {
    id: "crk",
    title: "Здание ЦРК",
    image: crk,
    text: "Построено в 1926 году в стиле «конструктивизм». В здании размещалось  Середское потребительское общество, основанное еще в 1915 г., позднее оно было переименовано в Центральный рабочий кооператив.  В 1958 г. на 2 этаже  был открыт Дом пионеров, на первом этаже был магазин «Ткани». На сегодняшний день помещение бездействует. Фасад здания был изменен.",
  },
];

export default objectsData;
